import { render, staticRenderFns } from "./PlgUnit.vue?vue&type=template&id=54ea350a&scoped=true"
import script from "./PlgUnit.vue?vue&type=script&lang=js"
export * from "./PlgUnit.vue?vue&type=script&lang=js"
import style0 from "./PlgUnit.vue?vue&type=style&index=0&id=54ea350a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea350a",
  null
  
)

export default component.exports